import {Pipe, PipeTransform} from "@angular/core";
import { IManagableObject } from "../../admin-panel/IManagableObject";

export class NameAndListFilterModel {
  public term = "";
  public excludelist: IManagableObject[] = [];
}


@Pipe({
    name: 'filterByNameAndList',
    pure: false,
    standalone: false
})
export class FilterByNameAndListPipe implements PipeTransform
{
  transform(items: IManagableObject[], term: NameAndListFilterModel): any
  {
    if (!items) return [];
    if (!term || (term.term == "" && term.excludelist.length == 0)) return items;

    let hash = {};
    for (let i = 0; i < term.excludelist.length; i++)
      hash[term.excludelist[i].Id] = term.excludelist[i];

    let lowerCaseTerm = term.term.toLowerCase();
    var res = [];
    for (let i = 0; i < items.length; i++)
      if (items[i].Name.toLowerCase().indexOf(lowerCaseTerm) >= 0 && !hash[items[i].Id])
        res.push(items[i]);
      //else
        //items[i].IsChecked = false;
    return res;
  }
}
